import { z } from "zod";

export enum EDtdResponse {
  SITE_NOT_VX = "SITE_NOT_VX",
  HAVE_GE = "HAVE_GE",
  HAVE_PAC = "HAVE_PAC",
  TEMPERATURE_ACQUISITION_CT_NOT_OK_NOW_OK = "TEMPERATURE_ACQUISITION_CT_NOT_OK_NOW_OK",
  TEMPERATURE_ACQUISITION_CT_NOT_OK_NOW_NOT_OK = "TEMPERATURE_ACQUISITION_CT_NOT_OK_NOW_NOT_OK",
  TEMPERATURE_ACQUISITION_MODULATOR_NOT_OK_NOW_OK = "TEMPERATURE_ACQUISITION_MODULATOR_NOT_OK_NOW_OK",
  TEMPERATURE_ACQUISITION_MODULATOR_NOT_OK_NOW_NOT_OK = "TEMPERATURE_ACQUISITION_MODULATOR_NOT_OK_NOW_NOT_OK",
  RECENT_DISCOMFORT_AND_VOLTALIS_DOESNT_CONTROL = "RECENT_DISCOMFORT_AND_VOLTALIS_DOESNT_CONTROL",
  NO_CONSUMPTION_FOUND = "NO_CONSUMPTION_FOUND",
  NO_TEMPERATURE_CONTROL = "NO_TEMPERATURE_CONTROL",
  VERSION_IS_OUT_OF_DATE = "VERSION_IS_OUT_OF_DATE",
  NO_PROBLEM_FOUND = "NO_PROBLEM_FOUND",
  CALIBRATION_NEEDED_HOT = "CALIBRATION_NEEDED_HOT",
  CALIBRATION_NEEDED_COLD = "CALIBRATION_NEEDED_COLD",
  IMPOSSIBLE_DIAGNOSIS = "IMPOSSIBLE_DIAGNOSIS",
}

const dtdCalibrationPropertiesSchema = z.object({
  lastCalibrationTemperature: z.number(),
  lastCalibrationDate: z.string().datetime(),
});

export const dtdTypeDtoSchema = z.object({
  key: z.nativeEnum(EDtdResponse),
  properties: dtdCalibrationPropertiesSchema.nullable(),
});
export type TDtdTypeDto = z.infer<typeof dtdTypeDtoSchema>;
